module.exports = __webpack_public_path__ + "img/l-hd.ccef94bc.webp";